var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.732c1.333-.77 2-1.155 2-1.732s-.667-.962-2-1.732l-2.25-1.3c-1.333-.769-2-1.154-2.5-.865-.5.288-.5 1.058-.5 2.598v2.598c0 1.54 0 2.31.5 2.598.5.289 1.167-.096 2.5-.866l2.25-1.299z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default "data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjIyIiBoZWlnaHQ9IjIyIiB2aWV3Qm94PSIwIDAgMjIgMjIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMy41IDEyLjczMkMxNC44MzMzIDExLjk2MjIgMTUuNSAxMS41NzczIDE1LjUgMTAuOTk5OUMxNS41IDEwLjQyMjYgMTQuODMzMyAxMC4wMzc3IDEzLjUgOS4yNjc4N0wxMS4yNSA3Ljk2ODgzQzkuOTE2NjcgNy4xOTkwMyA5LjI1IDYuODE0MTMgOC43NSA3LjEwMjgxQzguMjUgNy4zOTE0OCA4LjI1IDguMTYxMjggOC4yNSA5LjcwMDg4VjEyLjI5OUM4LjI1IDEzLjgzODYgOC4yNSAxNC42MDg0IDguNzUgMTQuODk3QzkuMjUgMTUuMTg1NyA5LjkxNjY3IDE0LjgwMDggMTEuMjUgMTQuMDMxTDEzLjUgMTIuNzMyWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };